import React, { forwardRef, useImperativeHandle, useRef } from "react";
import { Bar } from "react-chartjs-2";
import { get_config_gou } from "./config.js";
import { on_update_gou_callback } from "./updateCharLogic.js";

const INITIAL_DATA = {
	labels: [""],
	datasets: [
		{
			label: "Факт",
			axis: "y",
			data: [0],
			fill: false,
			borderColor: "#00770099",
			backgroundColor: "#00770099",
		},
		{
			label: "2",
			axis: "y",
			data: [1000],
			fill: false,
			borderColor: "#8a8a8a33",
			backgroundColor: "#8a8a8a33",
		},
	],
};

const GouChart = forwardRef(function GouChart(_props, ref) {
	const chartRef = useRef(null);

	useImperativeHandle(ref, () => ({
		applyRealtimeUpdate(data, station, axis = "y") {
			const chart = chartRef.current;
			if (!chart) return;
			on_update_gou_callback(chart, data, station, axis);
			chart.update();
		},
		setStats({ minv, maxv, mode = "y" }) {
			const chart = chartRef.current;
			if (!chart) return;
			chart.data = INITIAL_DATA;
			chart.options = get_config_gou(mode, minv, maxv);
			chart.update();
		},
	}));

	return (
		<div
			className="chart"
			style={{ width: "100%", margin: "auto", position: "relative" }}
		>
			<Bar
				style={{ height: "224px", width: "100%" }}
				ref={chartRef}
				data={INITIAL_DATA}
			/>
		</div>
	);
});

// Без props, полностью управляется через ref — не должен перерендериваться
// из-за родителя (тот же принцип, что у MainLineChart/Rt3MinChart).
export default React.memo(GouChart);
